export default {
    props: {
        index: {
            type: Number,
            default: 0
        },
    },

    data() {
        return {}
    },

    mounted() {
        // broadcast default config
        this.emitConfig()
    },

    methods: {
        emitConfig() {
            this.$emit('config', {
                valid: this.validate()
            })
        },

        validate() {
            return true;
        },
    },

    computed: {
        isNotValid() {
            return !this.validate()
        }
    }
}
